export { default } from './CustomNodeWidget.container'



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/CustomNode/CustomNodeWidget/index.js